import React, { Fragment, PropsWithChildren, PureComponent } from 'react';

import styled from 'styled-components';

import Box from '../atoms/Box/Box';
import { Col, Row } from '../atoms/Grid';
import Icon from '../atoms/Icon';
import Text from '../atoms/Text/Text';

import { AccordionList, AccordionValue } from './Accordion';

const Description = styled(Text)`
  a {
    color: ${props => props.theme.colors.turquoise};
  }
`;

type AccountAccordionValueProps = {
  title: string;
  onChange?: () => void;
  on?: boolean;
  duration?: number;
};

class AccountAccordionValue extends PureComponent<
  PropsWithChildren<AccountAccordionValueProps>
> {
  render() {
    const { onChange, on, title, children } = this.props;

    return (
      <Fragment>
        <AccordionValue onChange={onChange}>
          <Row between="xs" middle="xs">
            <Col xs>
              <Text
                color="cornflowerBlue"
                smSize={1.125}
                size={1.5}
                weight={600}
                lineHeight="normal"
              >
                {title}
              </Text>
            </Col>
            <Col>
              <Icon
                name="arrow2"
                color="grayChateau"
                size={1}
                rotate={on ? -90 : 90}
              />
            </Col>
          </Row>
        </AccordionValue>
        <AccordionList on={on} duration={this.props.duration}>
          <Box mt={0.75}>
            <Description
              color="cornflowerBlue"
              smSize={1.125}
              size={1.5}
              lineHeight={1.5}
            >
              {children}
            </Description>
          </Box>
        </AccordionList>
      </Fragment>
    );
  }
}

export default AccountAccordionValue;
